import { PlateTypeEnum } from "@ns/types";

export const PlateSelectProps = [
  {
    value: PlateTypeEnum.COMMERCIAL_STONE,
    label: "Komercijalni kamen",
  },
  {
    value: PlateTypeEnum.TABLE,
    label: "Tabla",
  },
  {
    value: PlateTypeEnum.READY_FORMATS,
    label: "Gotov format",
  },
];
